import React, { useEffect, useState } from 'react';
import { getDept, deleteDept } from '../../api/deptApi';

function DeptView({ code, comCode, comName, onEdit, onDeleted  }) {
  const [dept, setDept] = useState(null);

  useEffect(() => {
    if (!comCode) return;
    getDept(code, comCode).then(res => setDept(res.data));
  }, [code, comCode]);

  if (!dept) return <p>불러오는 중...</p>;

  const handleDelete = async () => {
    if (window.confirm('정말 이 부서를 삭제하시겠습니까?')) {
      try {
        await deleteDept(code, comCode);
        alert('부서가 삭제되었습니다.');
        if (onDeleted) onDeleted(); // ✅ 상위 컴포넌트에 알림
      } catch (err) {
        alert('삭제 실패: ' + err.message);
      }
    }
  };

  return (
    <div>
      <h3>{comName ? `${comName} | ` : ''}📄 부서 상세</h3>
      <p><strong>부서명:</strong> {dept.dept_name}</p>
      <p><strong>부서코드:</strong> {dept.dept_code}</p>
      <p><strong>상위부서:</strong> {dept.parent_dept_name} ({dept.parent_dept_code})</p>
      <p><strong>담당자 ID:</strong> {dept.manager_userid}</p>
      <div className="d-flex gap-2">
        <button className="btn btn-primary" onClick={() => onEdit(code)}>편집</button>
        <button className="btn btn-danger" onClick={handleDelete}>삭제</button>
      </div>

    </div>
  );
}

export default DeptView;